export const applications = {
  // Hero
  heroTitle: 'Applications',
  heroSubtitle: 'Proven performance across critical infrastructure and construction projects worldwide.',

  // Intro
  introTitle: 'Versatile Steel Fiber Solutions',
  introDesc: 'DYNAMIX hooked-end steel fibers are engineered to meet the demanding requirements of modern construction. From industrial floors to tunnel linings, our fibers deliver consistent performance and reliability across a wide range of applications.',

  // Applications
  app1Title: 'Industrial & Commercial Floors',
  app1Desc: 'High-traffic warehouses, distribution centers, manufacturing facilities, and retail spaces require durable flooring solutions. DYNAMIX steel fibers provide superior crack control, impact resistance, and load-bearing capacity, reducing maintenance costs and extending floor service life.',
  app1Benefits: 'Benefits',
  app1Benefit1: 'Eliminates need for welded wire mesh',
  app1Benefit2: 'Reduces slab thickness requirements',
  app1Benefit3: 'Improves resistance to heavy loads',
  app1Benefit4: 'Minimizes joint maintenance',

  app2Title: 'Tunnel Linings',
  app2Desc: 'Underground infrastructure demands exceptional durability and safety. Steel fiber reinforced shotcrete provides superior performance in tunnel construction, offering excellent crack control, impact resistance, and long-term structural integrity in challenging underground environments.',
  app2Benefits: 'Benefits',
  app2Benefit1: 'Enhanced shotcrete adhesion',
  app2Benefit2: 'Superior crack resistance',
  app2Benefit3: 'Improved safety during construction',
  app2Benefit4: 'Reduced rebound in shotcrete application',

  app3Title: 'Bridge Decks & Infrastructure',
  app3Desc: 'Highway and railway bridges face constant traffic loads and environmental exposure. DYNAMIX steel fibers enhance concrete durability, control cracking from thermal stress and shrinkage, and improve resistance to freeze-thaw cycles and de-icing chemicals.',
  app3Benefits: 'Benefits',
  app3Benefit1: 'Extended service life',
  app3Benefit2: 'Reduced maintenance requirements',
  app3Benefit3: 'Improved fatigue resistance',
  app3Benefit4: 'Better durability in harsh conditions',

  app4Title: 'Precast Concrete Elements',
  app4Desc: 'Architectural and structural precast components benefit from the enhanced properties of steel fiber reinforcement. Our fibers improve handling strength, reduce cracking during demolding and transportation, and allow for thinner, lighter elements without compromising performance.',
  app4Benefits: 'Benefits',
  app4Benefit1: 'Faster production cycles',
  app4Benefit2: 'Reduced element thickness',
  app4Benefit3: 'Improved surface finish',
  app4Benefit4: 'Lower transportation costs',

  app5Title: 'Hydraulic Structures',
  app5Desc: 'Dams, water treatment facilities, and marine structures require concrete that can withstand constant water exposure and hydraulic forces. Steel fiber reinforcement provides excellent crack control, abrasion resistance, and durability in wet environments.',
  app5Benefits: 'Benefits',
  app5Benefit1: 'Superior waterproofing',
  app5Benefit2: 'Excellent abrasion resistance',
  app5Benefit3: 'Reduced permeability',
  app5Benefit4: 'Long-term durability in wet conditions',

  app6Title: 'Overlays & Repairs',
  app6Desc: 'Concrete repair and overlay applications demand materials that bond well with existing structures and resist cracking. DYNAMIX steel fibers enhance bond strength, control shrinkage cracking, and improve the long-term performance of repair work.',
  app6Benefits: 'Benefits',
  app6Benefit1: 'Excellent bond to substrate',
  app6Benefit2: 'Reduced shrinkage cracking',
  app6Benefit3: 'Faster application',
  app6Benefit4: 'Extended repair lifespan',

  // CTA
  ctaTitle: 'Find the Right Solution for Your Project',
  ctaSubtitle: 'Our technical team is ready to help you select the optimal steel fiber specification and dosage for your specific application.',
  getTechnicalSupport: 'Get Technical Support',

  // More Applications
  moreAppsTitle: 'More Applications',
  moreAppsSubtitle: 'Versatile solutions for diverse construction challenges.',

  precastTitle: 'Precast Elements',
  precastDesc: 'Ideal for precast concrete panels, beams, and architectural elements requiring high strength and durability.',

  pavementsTitle: 'Pavements & Roads',
  pavementsDesc: 'Enhances concrete pavement performance, reducing cracking and extending service life under heavy traffic.',

  foundationsTitle: 'Foundation Slabs',
  foundationsDesc: 'Provides superior crack control and load distribution for residential and commercial foundation systems.',

  waterTanksTitle: 'Water Tanks & Pools',
  waterTanksDesc: 'Excellent for water-retaining structures, providing crack resistance and waterproofing enhancement.',

  blastResistantTitle: 'Blast-Resistant Structures',
  blastResistantDesc: 'Improves impact and blast resistance for security-critical infrastructure and military applications.',

  seismicTitle: 'Seismic Zones',
  seismicDesc: 'Enhanced ductility and energy absorption for structures in earthquake-prone regions.',
};
